.page {
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
	padding-right: 1rem;
}

.descriptionRow {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	gap: 3rem;
	width: 100%;
}

.addButton:global(.MuiButton-root) {
	min-width: fit-content;
	width: 200px;
	padding: 0.5rem;
	height: 35px;
}

.sessionsList {
	display: flex;
	flex-direction: column;
	gap: 0.9375rem;
	width: 100%;
}

.sessionEntry {
	display: flex;
	flex-direction: column;
	background: #fff;
	border: 1px solid #e5e7eb;
	border-radius: 16px;
	width: 100%;
}

.expandedSessionEntryWrapper {
	padding: 0.9375rem;
	gap: 0.9375rem;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
	border-top: 1px solid #e5e7eb;
	box-sizing: border-box;
}

.sessionEditorContainer {
	display: flex;
	flex-direction: column;
	width: 100%;
	border-radius: 12px;
	border: 1px solid #ededed;
	box-sizing: border-box;
	padding: 0.9375rem;
	background-color: #fff;
	gap: 0.875rem;
	box-sizing: border-box;
}

.addToolbar {
	position: sticky;
	top: 0;
	z-index: 10;
	display: flex;
	align-items: center;
	padding: 0.75rem !important;
	box-sizing: border-box;
	gap: 0.5rem;
}

.guidelineIframe {
	width: 100%;
	height: 370px;
	border: 0px;
	display: block;
	opacity: 1;
	position: relative;
	pointer-events: auto;

	&.loading {
		opacity: 0;
		position: absolute;
		pointer-events: none;
	}
}

.guidelineWrapper {
	position: relative;
	width: 100%;
	height: 370px;
}

.guidelineSkeleton:global(.MuiSkeleton-root) {
	width: 100%;
	height: 370px;
	position: absolute;
	top: 0;
	left: 0;
}

@media (max-width: 768px) {
	.page {
		padding-right: unset;
		padding: 0.5rem;
	}

	.addButton:global(.MuiButton-root) {
		width: 100%;
		min-width: unset;
		padding: 0.5rem;
	}

	.descriptionRow {
		/* For sticky */
		display: contents;
	}
}
